/* Cart page: change quantities, remove books and save the note without reloading */
(function(){
  var busy=false,queue=null,noteT,stepT;
  function root(){return document.querySelector('[data-mb-cart-root]')}
  function setCount(n){document.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=n})}
  function refresh(){
    return fetch('/cart?section_id=mb-cart',{credentials:'same-origin'}).then(function(r){return r.text()}).then(function(html){
      var d=document.createElement('div');d.innerHTML=html;
      var fresh=d.querySelector('[data-mb-cart-root]'),cur=root();if(!fresh||!cur)return;
      var newForm=fresh.querySelector('[data-mb-cart]'),oldForm=cur.querySelector('[data-mb-cart]');
      if(!newForm||!oldForm){location.reload();return}
      var y=window.scrollY;oldForm.parentNode.replaceChild(newForm,oldForm);window.scrollTo(0,y);
      document.dispatchEvent(new CustomEvent('mb:cartdrawn'));
      var nh=fresh.querySelector('[data-cart-head]'),oh=cur.querySelector('[data-cart-head]');if(nh&&oh)oh.textContent=nh.textContent;
      return fetch('/cart.js').then(function(r){return r.json()}).then(function(c){setCount(c.item_count)});
    });
  }
  function change(key,qty){
    if(busy){queue=[key,qty];return}
    busy=true;var f=root().querySelector('[data-mb-cart]');if(f)f.classList.add('is-busy');
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})})
      .then(function(c){if(c.item_count===0){location.reload();return}return refresh()})
      .catch(function(e){var t=document.querySelector('.mb-toast');if(t){t.textContent=(e&&e.description)||'Could not update the cart';t.classList.add('is-on');setTimeout(function(){t.classList.remove('is-on')},2600)}return refresh()})
      .finally(function(){busy=false;var f2=root()&&root().querySelector('[data-mb-cart]');if(f2)f2.classList.remove('is-busy');if(queue){var q=queue;queue=null;change(q[0],q[1])}});
  }
  document.addEventListener('click',function(e){
    var step=e.target.closest('[data-cart-step]');
    if(step){
      var li=step.closest('[data-key]'),inp=li.querySelector('[data-cart-qty]'),max=parseInt(inp.max||'999',10);
      var v=Math.max(0,Math.min(max,(parseInt(inp.value,10)||0)+parseInt(step.getAttribute('data-cart-step'),10)));
      inp.value=v;clearTimeout(stepT);stepT=setTimeout(function(){change(li.getAttribute('data-key'),v)},350);return;
    }
    var rm=e.target.closest('[data-cart-remove]');
    if(rm){e.preventDefault();var l=rm.closest('[data-key]');l.classList.add('is-going');change(l.getAttribute('data-key'),0)}
    var sw=e.target.closest('[data-set-switch]');
    if(sw){ // swap single volumes for the set: add the set, then take one of each volume out
      sw.disabled=true;sw.textContent='Switching…';
      var upd={};(sw.getAttribute('data-set-keys')||'').split(',').filter(Boolean).forEach(function(kq){var i=kq.lastIndexOf(':');upd[kq.slice(0,i)]=Math.max(0,parseInt(kq.slice(i+1),10)-1)});
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:+sw.getAttribute('data-set-switch'),quantity:1}]})})
        .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})})
        .then(function(){return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates:upd})})})
        .then(function(){return refresh()})
        .catch(function(err){var t=document.querySelector('.mb-toast');if(t){t.textContent=(err&&err.description)||'Could not switch to the set';t.classList.add('is-on');setTimeout(function(){t.classList.remove('is-on')},2600)}return refresh()});
      return;
    }
    var sr=e.target.closest('[data-set-remove]');
    if(sr){var u={};sr.getAttribute('data-set-remove').split(',').filter(Boolean).forEach(function(k){u[k]=0});
      var g=sr.closest('.mb-setgroup');if(g)g.classList.add('is-going');sr.disabled=true;
      fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates:u})})
        .then(function(r){return r.json()}).then(function(c){if(c.item_count===0){location.reload();return}return refresh()})
        .catch(function(){location.reload()});}
  });
  document.addEventListener('change',function(e){
    var inp=e.target.closest('[data-cart-qty]');if(!inp)return;
    var li=inp.closest('[data-key]'),v=Math.max(0,parseInt(inp.value,10)||0);change(li.getAttribute('data-key'),v);
  });
  document.addEventListener('input',function(e){
    var n=e.target.closest('[data-cart-note]');if(!n)return;
    clearTimeout(noteT);noteT=setTimeout(function(){fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({note:n.value})})},600);
  });
  document.addEventListener('keydown',function(e){if(e.key==='Enter'&&e.target.closest('[data-cart-qty]')){e.preventDefault();e.target.blur()}});
  document.addEventListener('mb:cart',function(){refresh()});
})();

/* Share this cart: a link carrying variant:quantity pairs; the person who opens it picks what to add */
(function(){
  function esc(t){var d=document.createElement('div');d.textContent=t==null?'':t;return d.innerHTML}
  function link(){
    var f=document.querySelector('[data-mb-cart]');if(!f)return location.origin+'/cart';
    var u=new URL(location.origin+'/cart');u.searchParams.set('shared',f.getAttribute('data-share'));return u.toString();
  }
  function pop(){return document.querySelector('[data-share-pop]')}
  function closePop(){var p=pop(),b=document.querySelector('[data-share-open]');if(p)p.hidden=true;if(b)b.setAttribute('aria-expanded','false')}
  document.addEventListener('click',function(e){
    var open=e.target.closest('[data-share-open]');
    if(open){var p=pop();if(!p)return;p.hidden=!p.hidden;open.setAttribute('aria-expanded',p.hidden?'false':'true');return}
    if(e.target.closest('[data-share-wa]')){window.open('https://wa.me/?text='+encodeURIComponent(link()),'_blank','noopener');closePop();return}
    var cp=e.target.closest('[data-share-copy]');
    if(cp){
      var url=link(),lab=cp.querySelector('span'),done=function(){lab.textContent='Copied';setTimeout(function(){lab.textContent='Copy link';closePop()},1200)};
      if(navigator.clipboard)navigator.clipboard.writeText(url).then(done,function(){prompt('Copy this link',url)});else prompt('Copy this link',url);
      return;
    }
    if(!e.target.closest('.mb-sharewrap'))closePop();
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closePop()});

  // ---------- recipient ----------
  function initShared(){
    var u=new URL(location.href),raw=u.searchParams.get('shared'),box=document.querySelector('[data-mb-shared]');
    if(!raw||!box||!window.mbLoad)return;
    var want={};
    raw.split(',').forEach(function(p){var b=p.split(':'),id=parseInt(b[0],10),q=Math.max(1,Math.min(99,parseInt(b[1],10)||1));if(id)want[id]=q});
    window.mbLoad('/collections/all','local').then(function(items){
      var books=items.filter(function(it){return want[it.vid]}).map(function(it){return {it:it,q:want[it.vid],on:it.av}});
      if(!books.length)return;
      function render(){
        var sel=books.filter(function(b){return b.on}),tot=0,mrp=0,n=0;
        sel.forEach(function(b){tot+=b.it.p*b.q;mrp+=(b.it.c>b.it.p?b.it.c:b.it.p)*b.q;n+=b.q});
        var m=window.mbMoney;
        box.innerHTML='<section class="mb-wrap mb-tone-lav mb-shared"><div class="mb-shared__grid"><div>'+
          '<h2 class="mb-h2" style="margin-bottom:18px">Shared with you</h2>'+
          '<ul class="mb-shared__list" role="list">'+books.map(function(b,i){var it=b.it;return '<li class="'+(b.on?'is-on':'')+(it.av?'':' is-out')+'"><label><input type="checkbox" data-sh="'+i+'"'+(b.on?' checked':'')+(it.av?'':' disabled')+'>'+
            '<span class="im">'+(it.img?'<img src="'+esc(it.img)+'" alt="" loading="lazy">':'')+'</span>'+
            '<span class="tx"><b>'+esc(it.t)+'</b><small>'+esc([it.a,it.v].filter(Boolean).join(' · '))+'</small>'+(it.av?'':'<em>Sold out</em>')+'</span>'+
            '<span class="pr"><b>'+m(it.p)+'</b>'+(b.q>1?'<small>× '+b.q+'</small>':'')+'</span></label><a href="/products/'+it.h+'" class="see">See the book →</a></li>'}).join('')+'</ul></div>'+
          '<aside class="mb-shared__sum"><span class="mb-eyebrow">Your selection · '+n+(n===1?' book':' books')+'</span><b class="tot">'+m(tot)+'</b>'+(mrp>tot?'<span class="sv">You save '+m(mrp-tot)+' on the printed price</span>':'')+
          '<button type="button" class="mb-btn mb-btn--gold" data-sh-add'+(n?'':' disabled')+'>Add to my cart</button>'+
          '<button type="button" class="mb-btn mb-btn--line" data-sh-all>Select everything</button>'+
          '<button type="button" class="mb-shared__skip" data-sh-skip>Hide</button></aside></div></section>';
        box.hidden=false;
      }
      render();
      box.addEventListener('change',function(e){var c=e.target.closest('[data-sh]');if(!c)return;books[+c.getAttribute('data-sh')].on=c.checked;render()});
      box.addEventListener('click',function(e){
        if(e.target.closest('[data-sh-all]')){books.forEach(function(b){if(b.it.av)b.on=true});render();return}
        if(e.target.closest('[data-sh-skip]')){box.hidden=true;clean();return}
        var add=e.target.closest('[data-sh-add]');if(!add)return;
        var items=books.filter(function(b){return b.on}).map(function(b){return {id:b.it.vid,quantity:b.q}});if(!items.length)return;
        add.disabled=true;add.textContent='Adding…';
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
          .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})})
          .then(function(){clean();location.reload()})
          .catch(function(err){add.disabled=false;add.textContent='Add to my cart';var t=document.querySelector('.mb-toast');if(t){t.textContent=(err&&err.description)||'Some books could not be added';t.classList.add('is-on');setTimeout(function(){t.classList.remove('is-on')},3000)}});
      });
    }).catch(function(){});
    function clean(){var v=new URL(location.href);v.searchParams.delete('shared');history.replaceState(null,'',v.toString())}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initShared);else initShared();
})();
/* 5+ copies of any one book: offer a quote once with a popup; the card in the summary stays */
(function(){
  var KEY='mbq_pop';
  function seen(){try{return localStorage.getItem(KEY)==='1'}catch(e){return true}}
  function mark(){try{localStorage.setItem(KEY,'1')}catch(e){}}
  function check(){
    var f=document.querySelector('[data-mb-cart]'),pop=document.querySelector('[data-qpop]');if(!f||!pop)return;
    if(f.getAttribute('data-bulk')==='1'&&!seen()){mark();pop.hidden=false;var b=pop.querySelector('[data-qpop-close]');if(b)b.focus()}
  }
  document.addEventListener('click',function(e){
    var pop=document.querySelector('[data-qpop]');if(!pop||pop.hidden)return;
    if(e.target.closest('[data-qpop-close]')||e.target===pop)pop.hidden=true;
  });
  document.addEventListener('keydown',function(e){var pop=document.querySelector('[data-qpop]');if(e.key==='Escape'&&pop&&!pop.hidden)pop.hidden=true});
  // after each quantity change the form is swapped in again, so watch for it
  new MutationObserver(check).observe(document.querySelector('[data-mb-cart-root]')||document.body,{childList:true,subtree:true});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',check);else check();
})();
/* Tick boxes beside each book: untick a book to leave it out of this order.
   Unticked books stay in the cart. At checkout they are set aside, and they come back to the cart on the next visit. */
(function(){
  var OFF='mb_cart_off',PARK='mb_cart_parked',WL='mb_wishlist';
  function get(k,d){try{return JSON.parse(localStorage.getItem(k)||'null')||d}catch(e){return d}}
  function put(k,v){try{if(v==null)localStorage.removeItem(k);else localStorage.setItem(k,JSON.stringify(v))}catch(e){}}
  function money(p){return window.mbMoney?window.mbMoney(p):'₹'+(p/100).toFixed(2)}
  function toast(t){var el=document.querySelector('.mb-toast');if(!el)return;el.textContent=t;el.classList.add('is-on');setTimeout(function(){el.classList.remove('is-on')},2600)}
  function lines(){return [].slice.call(document.querySelectorAll('[data-mb-cart] .mb-line[data-vid]'))}
  function picked(){return lines().filter(function(l){var c=l.querySelector('[data-cart-sel]');return c&&c.checked})}
  function json(url,body){return fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)}).then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})})}

  function paint(){
    var all=lines();if(!all.length)return;
    var off=get(OFF,{});
    all.forEach(function(l){var c=l.querySelector('[data-cart-sel]');if(!c)return;if(!c.dataset.ready){c.checked=!off[l.dataset.vid];c.dataset.ready='1'}l.classList.toggle('is-off',!c.checked)});
    var on=picked(),n=on.length,tot=all.length;
    var a=document.querySelector('[data-sel-all]');if(a){a.checked=n===tot;a.indeterminate=n>0&&n<tot}
    var cnt=document.querySelector('[data-sel-count]');if(cnt)cnt.textContent=n===tot?('All '+tot+' selected'):(n+' of '+tot+' selected');
    document.querySelectorAll('[data-sel-later],[data-sel-remove]').forEach(function(b){b.disabled=n===0});
    var sum=document.querySelector('[data-selsum]'),go=document.querySelector('[data-cart-go]');
    if(n<tot){
      var books=0,pay=0;on.forEach(function(l){books+=+l.dataset.qty;pay+=+l.dataset.line});
      if(sum){sum.hidden=false;sum.innerHTML=n?('Buying now: <b>'+money(pay)+'</b> for '+books+(books===1?' book':' books')+'. The '+(tot-n)+' unticked '+(tot-n===1?'book stays':'books stay')+' in your cart for later. Volume discounts are worked out on the books you buy.'):'Tick at least one book to check out.'}
      if(go)go.disabled=n===0;
    }else{if(sum)sum.hidden=true;if(go)go.disabled=false}
    // phone bottom bar follows the selection and the fresh cart form
    var st=document.querySelector('[data-sticky-tot]'),sn=document.querySelector('[data-sticky-n]'),sb=document.querySelector('.mb-sticky [data-sticky-go]');
    if(st){var books2=0,pay2=0;on.forEach(function(l){books2+=+l.dataset.qty;pay2+=+l.dataset.line});
      var full=document.querySelector('.mb-cart__sum .tot b');
      st.textContent=n<tot?money(pay2):(full?full.textContent:money(pay2));
      if(sn)sn.textContent=(n<tot?'Buying now · ':'To pay · ')+books2+(books2===1?' book':' books');
      if(sb)sb.disabled=n===0}
    if(window.mbStickySetup)window.mbStickySetup();
  }
  function save(){var off={};lines().forEach(function(l){var c=l.querySelector('[data-cart-sel]');if(c&&!c.checked)off[l.dataset.vid]=true});put(OFF,Object.keys(off).length?off:null)}

  // books set aside at the last checkout come back first
  function unpark(){
    var parked=get(PARK,null);if(!parked||!parked.length)return Promise.resolve(false);
    put(PARK,null);
    var off=get(OFF,{});parked.forEach(function(it){off[it.id]=true});put(OFF,off);
    return json('/cart/add.js',{items:parked}).then(function(){return true}).catch(function(){return true});
  }

  document.addEventListener('change',function(e){
    if(e.target.closest('[data-cart-sel]')){save();paint();return}
    var a=e.target.closest('[data-sel-all]');
    if(a){lines().forEach(function(l){var c=l.querySelector('[data-cart-sel]');if(c)c.checked=a.checked});save();paint()}
  });
  document.addEventListener('click',function(e){
    var rm=e.target.closest('[data-sel-remove]'),later=e.target.closest('[data-sel-later]');
    if(rm||later){
      var on=picked();if(!on.length)return;
      if(rm&&!confirm('Remove '+on.length+(on.length===1?' book':' books')+' from your cart?'))return;
      var u={};on.forEach(function(l){u[l.dataset.key]=0;l.classList.add('is-going')});
      if(later){var wl=get(WL,[]);on.forEach(function(l){if(wl.indexOf(l.dataset.handle)<0)wl.push(l.dataset.handle)});put(WL,wl)}
      json('/cart/update.js',{updates:u}).then(function(c){
        toast(later?'Saved to your wishlist':'Removed from your cart');
        if(c.item_count===0){location.reload();return}
        document.dispatchEvent(new CustomEvent('mb:cart'));
      }).catch(function(){location.reload()});
      return;
    }
    var go=e.target.closest('[data-cart-go]');
    if(go){
      var all=lines(),on=picked();if(on.length===all.length)return; // whole cart: normal checkout
      e.preventDefault();if(!on.length)return;
      var off=all.filter(function(l){return on.indexOf(l)<0}),u={},park=[];
      off.forEach(function(l){u[l.dataset.key]=0;park.push({id:+l.dataset.vid,quantity:+l.dataset.qty})});
      go.disabled=true;
      json('/cart/update.js',{updates:u}).then(function(){put(PARK,park);location.href='/checkout'})
        .catch(function(){go.disabled=false;toast('Could not start checkout. Please try again.')});
    }
  });
  // the cart section is swapped in again after every change
  var root=document.querySelector('[data-mb-cart-root]');
  // react only when a fresh cart form arrives; paint() itself changes text inside the root, so reacting to every change would loop forever
  function isForm(n){return n.nodeType===1&&(n.matches('[data-mb-cart]')||!!n.querySelector('[data-mb-cart]'))}
  if(root)new MutationObserver(function(ms){if(ms.some(function(m){return [].some.call(m.addedNodes,isForm)}))paint()}).observe(root,{childList:true,subtree:true});
  function start(){
    unpark().then(function(back){
      if(back){document.dispatchEvent(new CustomEvent('mb:cart'));toast('Books you left for later are back in your cart, unticked')}
      paint();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();

/* Books to add, shown under the savings bar. Picked from our own catalogue list (the one search uses):
   books from the wishlist first, then the same subject, then the same year or course as the books in the cart.
   Books already in the cart, other editions of them and volumes of sets in the cart are left out.
   "Gets you ₹X off": this book alone reaches the next cart saving.
   "No extra delivery": the parcel stays in the same delivery step (₹50 per kg, steps change at 1.5 kg, 2.5 kg ... up to 30.5 kg). */
(function(){
  function money(p){var r=p/100;return '₹'+r.toLocaleString('en-IN',{minimumFractionDigits:r%1?2:0,maximumFractionDigits:2})}
  function esc(t){var d=document.createElement('div');d.textContent=t==null?'':t;return d.innerHTML}
  function room(w){if(w>=30500)return Infinity;var edge=Math.max(1500,Math.floor((w+500)/1000)*1000+500);return edge-w}
  function key(t){return (t||'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim().slice(0,22)}
  function wish(){try{return JSON.parse(localStorage.getItem('mb_wishlist')||'[]')}catch(e){return []}}
  var FORMATS={'Atlas':1,'Exam Prep and revision':1,'Question Banks and MCQs':1,'Handbooks':1,'Evergreens':1,"Doctor's Treasure":1};
  function draw(){
    var box=document.querySelector('[data-ups]');if(!box||!window.mbLoad)return;
    var handles=(box.getAttribute('data-handles')||'').split(',').filter(Boolean);if(!handles.length)return;
    var skip={};(box.getAttribute('data-skip')||'').split(',').filter(Boolean).forEach(function(h){skip[h]=1});
    var gap=parseInt(box.getAttribute('data-gap')||'0',10)||0,off=parseInt(box.getAttribute('data-next-off')||'0',10)||0;
    var rm=room(parseInt(box.getAttribute('data-weight')||'0',10)||0),wl={};wish().forEach(function(h){wl[h]=1});
    window.mbLoad('/collections/all','local').then(function(items){
      var subj={},subs={},cats={},titles={},cartFmt={},n=0;
      items.forEach(function(it){if(handles.indexOf(it.h)<0)return;n++;titles[key(it.t)]=1;
        it.subj.forEach(function(x){subj[x]=1});it.subs.forEach(function(x){subs[x]=1});it.cats.forEach(function(x){if(!FORMATS[x])cats[x]=1;else cartFmt[x]=1})});
      if(!n){box.hidden=true;return}
      var pool=[],anyWish=false;
      items.forEach(function(it){
        if(skip[it.h]||!it.av||!it.p||titles[key(it.t)])return;
        var sj=it.subj.filter(function(x){return subj[x]}).length,sb=it.subs.filter(function(x){return subs[x]}).length,ct=it.cats.filter(function(x){return cats[x]}).length,w=!!wl[it.h];
        // same subject: a different kind of book (atlas, MCQs, revision, handbook) helps; a second textbook mostly doesn't
        var fmt=it.cats.filter(function(x){return FORMATS[x]&&x!=='Evergreens'&&x!=="Doctor's Treasure"});
        var newFmt=fmt.some(function(x){return !cartFmt[x]});
        var rel=(sj?(newFmt?12:fmt.length?6:2):0)+(sb?5:0)+(ct?1:0);
        if(!w&&(rel<4||!ct))return;   // same subject or same year, within the same course
        var c={it:it,w:w,closes:gap>0&&it.p>=gap,light:it.w>0&&it.w<=rm};
        c.score=(w?100:0)+rel+(c.closes?3:0)+(c.light?2:0)+(it.cats.indexOf('Evergreens')>-1?1:0);
        if(w)anyWish=true;pool.push(c);
      });
      if(!pool.length){box.hidden=true;return}
      pool.sort(function(a,b){return b.score-a.score||a.it.p-b.it.p});
      var pick=pool.slice(0,8);
      box.querySelector('[data-ups-h]').textContent=pick.some(function(c){return c.closes})?'Add one of these to save '+money(off*100):gap>0?'Get closer to '+money(off*100)+' off':'Goes well with your books';
      box.querySelector('[data-ups-sub]').textContent=anyWish?'From your wishlist and the subjects in your cart.':'From the same subjects and year as your cart.';
      box.querySelector('[data-ups-row]').innerHTML=pick.map(function(c){
        var it=c.it,url='/products/'+it.h;
        var tags=(c.w?'<span class="t t--wish">In your wishlist</span>':'')+(c.closes?'<span class="t t--save">Gets you '+money(off*100)+' off</span>':'')+(c.light?'<span class="t">No extra delivery</span>':'');
        var mrp=it.c>it.p?'<s>'+money(it.c)+'</s>':'';
        return '<div class="mb-ups__card"><a class="mb-ups__img" href="'+esc(url)+'">'+(it.img?'<img src="'+esc(it.img)+'" alt="" loading="lazy" width="150" height="200">':'')+'</a>'+
          '<div class="mb-ups__tags">'+tags+'</div><a class="mb-ups__t" href="'+esc(url)+'">'+esc(it.t)+'</a>'+
          '<div class="mb-ups__p"><b>'+money(it.p)+'</b>'+mrp+'</div>'+
          '<button type="button" class="mb-btn mb-btn--line" data-ups-add="'+it.vid+'">Add to cart</button></div>';
      }).join('');
      box.hidden=false;
    }).catch(function(){box.hidden=true});
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-ups-add]');if(!b)return;
    b.disabled=true;b.textContent='Adding…';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:+b.getAttribute('data-ups-add'),quantity:1}]})})
      .then(function(r){if(!r.ok)throw 0;document.dispatchEvent(new CustomEvent('mb:cart'))})
      .catch(function(){b.disabled=false;b.textContent='Add to cart';var t=document.querySelector('.mb-toast');if(t){t.textContent='Could not add this book';t.classList.add('is-on');setTimeout(function(){t.classList.remove('is-on')},2600)}});
  });
  document.addEventListener('mb:cartdrawn',draw);
  if(document.readyState==='complete')draw();else window.addEventListener('load',draw);
})();
